export default {
    computed: {
        isLastStep() {
            return this.step === this.steps[this.steps.length - 1].id
        },

        isFirstStep() {
            return this.step === this.steps[0].id
        },

        nextStep() {
            if (this.isLastStep) {
                return false
            }
            let stepIndex = 0

            this.steps.forEach((step, index) => {
                if (step.id === this.step) stepIndex = index
            })

            return this.steps[stepIndex + 1].id
        },

        prevStep() {
            if (this.isFirstStep) {
                return false
            }
            let stepIndex = 0

            this.steps.forEach((step, index) => {
                if (step.id === this.step) stepIndex = index
            })

            return this.steps[stepIndex - 1].id
        }
    }
}